module.exports = "https://coursera_assets.s3.amazonaws.com/images/52653c8817c0031d547d6df9251e52ef.png";